import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { SequenceListPage } from '../../../modules/sequences/sequence-list-page'

/**
 * `/sequences` - the sequence list + builder/enrollment editor. The Contacts
 * multi-select (PLAN-04) hands off here via `?contactIds=...` to enroll a
 * selection; `?sequenceId=...` opens the editor, `?create` starts a new sequence.
 * URL is the source of truth.
 */
const sequencesSearchSchema = z.object({
  contactIds: z.array(z.string()).optional(),
  sequenceId: z.string().optional(),
  create: z.boolean().optional(),
})

export const Route = createFileRoute('/_authed/sequences/')({
  validateSearch: sequencesSearchSchema,
  component: SequencesRoute,
})

function SequencesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()

  return (
    <SequenceListPage
      contactIds={search.contactIds ?? []}
      selectedSequenceId={search.sequenceId}
      creating={search.create === true}
      onSelect={(sequenceId) =>
        navigate({
          to: '/sequences',
          search: (prev) => ({ ...prev, sequenceId, create: undefined }),
        })
      }
      onCreate={() => navigate({ to: '/sequences', search: (prev) => ({ ...prev, create: true }) })}
      onCloseEditor={() =>
        navigate({
          to: '/sequences',
          search: (prev) => ({ ...prev, sequenceId: undefined, create: undefined }),
        })
      }
      onEnrolled={() =>
        navigate({ to: '/sequences', search: (prev) => ({ ...prev, contactIds: undefined }) })
      }
    />
  )
}
